import type {
  QuotationTarget,
  QuotationTargetType,
} from "@/features/quotation/types";

export const TARGET_LABELS: Record<QuotationTargetType, string> = {
  customer: "Cliente",
  store: "Loja",
};

export function targetBadge(target: Pick<QuotationTarget, "target_type">) {
  return TARGET_LABELS[target.target_type] ?? target.target_type;
}
